import { Box, Flex, Image, useBreakpointValue } from "@chakra-ui/react";
import { Container } from "components";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import type { SbEditableComponentProps } from "types/storyblok";
import type { PartnersHeroProps } from "./PartnersHero.d";

export const PartnersHero = ({
  content,
  marginBottom,
  backgroundImageUrlDesktop,
  backgroundImageUrlMobile,
  backgroundImageAlt,
  sbEditable,
}: SbEditableComponentProps<PartnersHeroProps>) => (
  <Container maxWidth="1296px">
    <Flex
      pt={{ base: 12, lg: 0 }}
      pb={32}
      px={{ base: 4, lg: 28 }}
      borderRadius={{ base: 0, lg: "2xl" }}
      bg="primary.100"
      justify="space-between"
      mb={{ base: (Number(marginBottom) / 100) * 80, lg: marginBottom }}
      align="center"
      flexDir={{ base: "column", lg: "row" }}
      {...sbEditable}
    >
      <Box>
        <RichtextAdapter
          content={content}
          customStyles={{ paragraph: { maxW: { base: "auto", lg: "517px" } }, heading: { maxW: "600px" } }}
        />
      </Box>
      <Flex minH="500px" align="center">
        <Image
          src={useBreakpointValue({ base: backgroundImageUrlMobile, lg: backgroundImageUrlDesktop }, { ssr: true })}
          objectFit="cover"
          alt={backgroundImageAlt}
        />
      </Flex>
    </Flex>
  </Container>
);
